<template>
  <div class="page-payment hardware-padding back-btn">
    <n-loader :loading="isLoading"/>
    <div v-show="showContainer" class="container">
      <c-frame v-if="show"
               bacroute="mobile.payment"
               :url="frameUrl"
               :show.sync="show"
      />
      <div v-if="paymentPlaceEnabled">
        <div class="available-cards">
          <div class="redirect-card">
            <div class="redirect-card-icon">
              <img :src="smartphoneIcn" alt="Блок"/>
            </div>
            <br>
            <div class="redirect-card-content">
              <div class="redirect-card-label">Для управления балансом и вывода средств на любую карту используйте
                приложение нашего финансового партнёра.
                <br>Это безопасно и займёт меньше минуты.
              </div>
            </div>
            <br><br>
            <a
                href="https://onelink.to/akttkj"
                class="redirect-link"
                target="_blank"
                rel="noopener"
            >
              Скачать и вывести&nbsp;&nbsp;
              <img :src="redirectIcn" class="redirect-link-icon"/>
            </a>
          </div>
        </div>
      </div>

      <template>
        <div class="payout-page">
          <div class="payout-container">

            <!-- Header Section -->

            <div class="page-header">
              <div style="display: flex; justify-content: center; align-items: center;">
                <div class="header-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21 12V7H3V17C3 18.1046 3.89543 19 5 19H11" stroke="#1976D2" stroke-width="2"
                          stroke-linecap="round"/>
                    <path d="M17 15L19 17L23 13" stroke="#1976D2" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M3 10H21" stroke="#1976D2" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
                <div class="header-text">
                  <h1 class="page-title">Вывод средств</h1>
                </div>
              </div>
            </div>
            <div class="available-cards">
              <div class="card">
                <div class="card-content">
                  <div class="card-value">{{ $n.formatNumber(user.salaryStats.availableToTake) }} ₸</div>
                  <div class="card-label">Доступно к выводу</div>
                </div>
            </div>
              <div v-if="user.salaryStats.startAmount !== 0" class="card">
                <div class="card-icon">
                  <img :src="changes" alt="Начальная сумма"/>
                </div>
                <div class="card-content">
                  <div class="card-value">{{ user.salaryStats.availableAmount }}</div>
                  <div class="card-label">
                    <t name="1.6.12"/>
                  </div>
                </div>
              </div>
            </div>
            <!-- Main Content -->
            <div class="payout-content">

              <!-- Card Selection -->
              <div class="section-card">
                <div class="section-header">
                  <div class="section-title">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <rect x="2" y="4" width="14" height="10" rx="2" stroke="#424242" stroke-width="1.5"/>
                      <path d="M2 7H16" stroke="#424242" stroke-width="1.5"/>
                    </svg>
                    <span>Карта получателя</span>
                  </div>
                  <span class="required-badge">Обязательно</span>
                </div>

                <div class="card-selector">
                  <card-select
                      :danger="$var('selectMessage')"
                      :value.sync="card"
                      :data="cards"
                      :text="company?.payoutProvider === 'bereke'"
                      @addcard="addProviderCard(company?.payoutProvider === 'buhta' ? 'showAddBuhtaCard' : 'showAddBerekeCard')"
                  />
                </div>
              </div>

              <!-- Add Card Form (когда выбрано добавление карты) -->
              <transition name="expand">
                <div v-if="card && card.id === 'add'" class="section-card add-card-section">
                  <div class="add-card-layout">

                    <!-- Card Preview -->
<!--                    <div class="card-preview-wrapper">-->
<!--                      <div class="card-visual">-->
<!--                        <div class="card-decoration">-->
<!--                          <div class="card-chip"></div>-->
<!--                        </div>-->
<!--                        <div class="card-number">{{ formattedCardNumber || '•••• •••• •••• ••••' }}</div>-->
<!--                        <div class="card-footer">-->
<!--                          <div class="card-holder">{{ cardHolder || 'CARDHOLDER NAME' }}</div>-->
<!--                          <div class="card-brand">VISA</div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->

                    <!-- Form Fields -->
                    <div class="card-form-wrapper">
                      <div class="form-field">
                        <label class="field-label">Номер карты</label>
                        <n-input
                            v-bind="$form.input('cardNumber')"
                            placeholder="0000 0000 0000 0000"
                            type="tel"
                            class="field-input"
                            :class="{ 'has-error': isAllNumberCard || isValidCard }"
                            @blur="validateCardNumber"
                        />
                        <transition name="fade">
                          <div v-if="isAllNumberCard || isValidCard" class="field-error">
                            <t v-if="isAllNumberCard" name="1.12.13"/>
                            <t v-if="isValidCard" name="1.12.14"/>
                          </div>
                        </transition>
                      </div>

                      <div class="form-field">
                        <label class="field-label">Имя держателя</label>
                        <n-input
                            v-model="cardHolder"
                            placeholder="IVAN IVANOV"
                            type="text"
                            class="field-input"
                            :class="{ 'has-error': isLatin || isNameTooLong || isSingleCharacterEntered }"
                            @blur="validateCardHolderName"
                            @input="formatCardHolder"
                        />
                        <transition name="fade">
                          <div v-if="isLatin || isNameTooLong || isSingleCharacterEntered" class="field-error">
                            <t v-if="isLatin" name="1.12.12"/>
                            <t v-if="isNameTooLong" name="1.12.10"/>
                            <t v-if="isSingleCharacterEntered" name="1.12.11"/>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="security-notice">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M7 1L3 2.5V6C3 8.5 4.5 11 7 12.5C9.5 11 11 8.5 11 6V2.5L7 1Z" stroke="#1976D2"
                            stroke-width="1.2" stroke-linejoin="round"/>
                      <path d="M5.5 6.5L6.5 7.5L8.5 5.5" stroke="#1976D2" stroke-width="1.2" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                    <span>Данные карты надежно защищены и не передаются третьим лицам</span>
                  </div>
                </div>
              </transition>

              <!-- Amount Section -->
              <div class="section-card">
                <div class="amount-header">
                  <span class="amount-label">Сумма вывода</span>
                  <span class="required-mark">*</span>
                </div>

                <div class="amount-input-wrapper">
                  <n-input
                      v-model="value"
                      type="tel"
                      placeholder="0"
                      class="amount-input"
                      :danger="$var('message')"
                  />
<!--                  <span class="currency-symbol">₸</span>-->
                </div>

                <div class="amount-breakdown">
                  <div class="breakdown-item">
                    <span class="breakdown-label">Комиссия</span>
                    <span class="breakdown-value">{{ $n.formatNumber(calculateCommission(value)) }} ₸</span>
                  </div>
                  <div class="breakdown-item total-row">
                    <span class="breakdown-label">К списанию</span>
                    <span class="breakdown-value">{{ $n.formatNumber(getTotalAmount(value)) }} ₸</span>
                  </div>
                </div>
              </div>

            </div>

            <!-- Submit Button -->
            <div class="submit-section">
              <n-button
                  class="submit-button"
                  type="submit"
                  @click="takeSumProvider"
              >
                <span class="button-text">Вывести&nbsp;&nbsp;</span>
                <span class="button-amount">{{ $n.formatNumber(getButtonAmount()) }} ₸</span>
              </n-button>
            </div>

          </div>
        </div>
      </template>
    </div>

    <!--      &lt;!&ndash;      Модальное окно с документом на подписание      &ndash;&gt;-->
    <!--      <div class="c-document-viewer">-->
    <!--        <div v-if="showDocumentModal" class="content">-->
    <!--          <div class="header-modal-document">-->
    <!--            <h4 class="text">-->
    <!--              <t name="5.5.3" />-->
    <!--            </h4>-->
    <!--            <n-button class="close-button" flat @click="closeDocumentModal">x</n-button>-->
    <!--          </div>-->
    <!--          <div class="body">-->
    <!--            <div ref="pdfContainer" class="pdf-container">-->
    <!--              <div class="pdf-controls">-->
    <!--                <button class="zoom-button-btn" @click="zoomIn">-</button>-->
    <!--                <button class="zoom-button-btn" @click="zoomOut">+</button>-->
    <!--              </div>-->
    <!--              <div id="pdfContainer"></div>-->
    <!--            </div>-->
    <!--            <n-button class="default-button" :disabled="addSignatureDisable" type="submit" @click="addSignature">-->
    <!--              <t name="5.5.6" />-->
    <!--            </n-button>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!-- Модальное окно с просмотром пользовательского соглашения -->
    <!--      <div class="agreement-modal" :class="{ 'agreement-modal__active': showModalAgreement }">-->
    <!--        <p class="agreement-modal__text block-title">-->
    <!--          <t name="1.9.6" />-->
    <!--        </p>-->
    <!--        <n-button class="user-default-button" @click.stop="openModalAgreement">-->
    <!--          <t name="1.9.7" />-->
    <!--        </n-button>-->
    <!--      </div>-->
    <c-mobile-appbar/>
    <c-mobile-app-header/>
  </div>
</template>
<script>
import bank from 'assets/bank/bank.svg'
import newCard from 'assets/new-card.svg'
import moneyIcon from 'assets/money-img.png'
import changes from 'assets/changes.svg'
import lock from 'assets/lock.svg'
import smartphoneIcn from 'assets/smartphone.png'
import redirectIcn from 'assets/redirect.svg'
import 'pdfjs-dist/legacy/build/pdf.worker.entry'
import * as pdfjsLib from 'pdfjs-dist'


export default {
  name: 'PaymentPage',
  data() {
    return {
      // eslint-disable-next-line max-len
      isLatin: false,
      needFcbVerification: false,
      showContainer: true,
      showDocument: false,
      isSingleCharacterEntered: false,
      isNameTooLong: false,
      showDocumentModal: false,
      needCheck: true,
      document: null,
      documentId: null,
      bank,
      smartphoneIcn,
      lock,
      redirectIcn,
      newCard,
      moneyIcon,
      changes,
      user: $app.auth.user(),
      showAddBuhtaCard: false,
      showAddBerekeCard: false,
      showWoopaySuccess: false,
      showBerekeSuccess: false,
      woopayAmount: '',
      woopayDateTime: '',
      woopayOperationId: '',
      berekeAmount: '',
      berekeDateTime: '',
      berekeOperationId: '',
      show: false,
      frameUrl: '',
      card: {},
      cards: [],
      value: '',

      cardHolder: '',
      isBtnDisabled: true,
      minCommission: 0,
      company: {},
      commission: 0,
      berekeCommission: 0,
      link: '',
      code: '',
      hideButton: false,
      isDisabled: true,
      addSignatureDisable: true,
      scale: 1,
      agreement: false,
      showModalAgreement: false,
      isValidCard: null,
      isAllNumberCard: null,
      needVerificationType: null,
      isDocumentSignatureRequired: false,

      //* новая логика транзакции
      firstStep: null,
      transactionStatus: null,
      transactionUuid: null,

      isLoading: true,
      COMPANY_BINS: {
        "ALSER": "081040013276",
        "TWO_WHEELS": "221240009078",
        "TWO_WHEELS_SECOND": "221240009070",
        "WEBDOSTAVKA": "250140028320",
        "WEBDOSTAVKA_SECOND": "250140028321",
        "TWO_WHEELS_CLC": "221240009078*",
        "TWO_WHEELS_CLC_SECOND": "221240009079"
      },

      PAYOUT_REDIRECT_COMPANIES: {
        'Vezunchik': '231240005760'
      },
      paymentPlaceEnabled: false,
    }
  },
  computed: {
    formattedCardNumber() {
      const value = this.$form.input('cardNumber').value || '';
      return value.replace(/(\d{4})(?=\d)/g, '$1 ');
    },
    isDisableBtn() {
      const availableToTake = this.user.salaryStats.availableToTake
      const isValidSumPrePay = +this.value > availableToTake;
      const isValidSumAfterPay = parseFloat(this.value) + this.calculateCommission(this.value) > this.user.salaryStats.availableToTake;
      const validSum = this.company.getCommission === 'afterPay' ? isValidSumAfterPay : isValidSumPrePay

      return this.isBtnDisabled ||
          this.isLatin ||
          this.isSingleCharacterEntered ||
          this.isNameTooLong ||
          !this.agreement ||
          this.isValidCard ||
          this.isAllNumberCard ||
          !this.value ||
          validSum
    },
    startTransactionData() {
      return this.$store.state.app.startTransaction;
    },
    withdrawalAmount() {
      const value = +this.value;
      return value >= 500 ? $n.formatNumber(value - this.calculateCommission(value)) : 0;
    },
    isBlockedEmployer() {
      return this.user.status === 'blocked'
    },
    isBlockedRockethand() {
      return this.user.useApp === 0
    }
  },
  watch: {
    value() {
      this.value = this.value.replace(/\D/g, '')
    },
    show() {
      if (!this.show) {
        this.getCards()
      }
    },
    card() {
      if (this.card?.id !== 'add') {
        this.isBtnDisabled = false
      } else {
        this.isBtnDisabled = true
      }
    },
    woopaycard() {
      if (this.card?.id !== 'add') {
        this.isBtnDisabled = false
      } else {
        this.isBtnDisabled = true
      }
    },
    berekecard() {
      if (this.card?.id !== 'add') {
        this.isBtnDisabled = false
      } else {
        this.isBtnDisabled = true
      }
    },
    cardNumber() {
      if (this.showAddBuhtaCard) {
        if (this.$form.input('cardNumber').value !== '' && this.cardHolder !== '') {
          this.isBtnDisabled = false
        } else {
          this.isBtnDisabled = true
        }
      }
      if (this.showAddBerekeCard) {
        if (this.$form.input('cardNumber').value !== '' && this.cardHolder !== '') {
          this.isBtnDisabled = false
        } else {
          this.isBtnDisabled = true
        }
      }
    },
    cardHolder() {
      if (this.showAddBuhtaCard) {
        if (this.$form.input('cardNumber').value !== '' && this.cardHolder !== '') {
          this.isBtnDisabled = false
        } else {
          this.isBtnDisabled = true
        }
      }
      if (this.showAddBerekeCard) {
        if (this.$form.input('cardNumber').value !== '' && this.cardHolder !== '') {
          this.isBtnDisabled = false
        } else {
          this.isBtnDisabled = true
        }
      }
    },
  },
  created() {
    $app.auth.needAuth(true)
    this.initRequests()

    this.$form.init({
      value: '',
      silent: true,
      cardNumber: ''
    })
    this.$form.rules({
      value: ['required', 'biggerThanMin',],
    })
    this.$form.masks({
      cardNumber: ['card'],
    })

    $app.store.action('app.updateUser')

    if (!this.isPaymentAllowed()) this.$router.push({name: 'mobile.index',})
  },
  methods: {
    async initRequests() {
      await this.getUser()
      await this.getCards()
      await this.loadCompany()
      await this.startTransaction()
      await this.checkPaymentRedirect()

      this.isLoading = false
    },
    async getUser() {
      try {
        const response = await $api.auth.info()
            .with('company')
            .with('salaryStats')
            .with('monthTaken');
        if (response) {
          this.user = response.data.content.user
        }
      } catch (error) {
        console.error("Ошибка загрузки пользователя");
        this.isLoading = false
      }
    },
    getTotalAmount(value) {
      const amount = parseFloat(value) || 0;
      const commission = this.calculateCommission(value);
      return amount + commission;
    },
    async loadCompany() {
      try {
        const response = await $api.companies.get(this.user.selectedCompany)
        this.company = response.data.content
        this.minCommission = this.company.minCommission
        this.$store.commit('app/setVerificationType', this.company.verificationType)
      } catch (error) {
        $app.ui.notify('Ошибка получения данных о компании', 'danger')
        this.isLoading = false
      }
    },

    async checkPaymentRedirect() {
      if (!this.company?.bin) {
        this.paymentPlaceEnabled = false;
        return;
      }

      this.paymentPlaceEnabled = Object
          .values(this.PAYOUT_REDIRECT_COMPANIES)
          .includes(this.company.bin);
    },
    async getCards() {
      this.cards = []
      this.cards.push({id: 'add', name: 'add', title: '', bank: '', issuer: 'Новая карта',})
      this.$var('load', true)

      try {
        const response = await $api.payment.getCardsNew()
        if (response.data.content?.length > 0) {
          $n.map(response.data.content, (e) => {
            const cardBin = e.mask.substr(0, 6)
            const bank = $n.getBankIcon(cardBin)
            this.cards.push({
              identifier: e.id,
              id: e.id,
              name: '',
              title: e.mask,
              issuer: '',
              bank: bank.name,
              bankIcon: bank.icon,
              issuerIcon: '',
            })
          })
        }

      } catch (error) {
        $app.ui.notify('Ошибка получения списка карт', 'danger')
        this.isLoading = false
      }
    },
    async startTransaction() {
      const data = {
        companyId: this.company.id,
        processName: "transaction"
      }
      try {
        const response = await $api.transactions.start(data)
        this.firstStep = await response.data.data.firstStep
        this.$store.commit('app/setStartTransaction', this.firstStep)
      } catch (error) {
        console.error('An error occurred.');
        $app.ui.notify('Произошла ошибка, попробуйте позднее (код 1)', 'danger')
        this.isLoading = false
      }
    },

    //* Валидация
    validateCardNumber() {
      const numberCard = this.$form.input('cardNumber').value.replace(/\s+/g, '').trim()

      if (numberCard.length !== 16) {
        this.isAllNumberCard = true
        return
      } else {
        this.isAllNumberCard = false
      }

      const digits = numberCard.split('').map(Number);

      const reversedDigits = digits.reverse();
      let sum = 0;

      for (let i = 0; i < reversedDigits.length; i++) {
        let digit = reversedDigits[i];

        if (i % 2 !== 0) {
          digit *= 2;

          if (digit > 9) {
            digit -= 9;
          }
        }
        sum += digit;
      }

      // 4405 6397 7288 6865
      (sum % 10 === 0) ? this.isValidCard = false : this.isValidCard = true;
    },
    validateCardHolderName() {
      if (this.cardHolder === '') {
        this.isLatin = false
        return
      }
      const latinRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/
      this.isLatin = !latinRegex.test(this.cardHolder)
      this.isNameTooLong = this.cardHolder.length > 31
      this.isSingleCharacterEntered = (this.cardHolder.trim().length <= 3) ? true : false
    },
    formatCardHolder() {
      this.cardHolder = this.cardHolder.trim().toUpperCase()
    },

    //* Работа с транзакциями
    handleInvalidSum(value) {
      if (!value) {
        $app.ui.notify(`${$app.secure.clean($n.t('3.20'))}`, 'danger');
      } else {
        value >= 1000 && this.company.minimalTransactionSum && this.company.minimalTransactionSum >= value ?
            $app.ui.notify(`${$app.secure.clean($n.t('3.27'))} ${this.company.minimalTransactionSum} ₸'`, 'danger') :
            $app.ui.notify(`${$app.secure.clean($n.t('3.27'))} 1000 ₸`, 'danger');
      }
    },
    calculateCommission(value) {

      if (!this.card) {
        this.card = this.cards[0];
      }
      let cardNumber = this.$form.input('cardNumber').value ?
          this.$form.input('cardNumber').value.replace(/\s+/g, '') :
          this.card.title

      let pan = '';

      if (this.cards.length === 1 && !this.cards[0].title && cardNumber) {
        pan = cardNumber;
      } else if (this.cards.length > 1 || (this.cards.length === 1 && this.cards[0].title)) {
        pan = cardNumber;
      }

      if (value > 0) {
        const data = {
          sum: value,
          pan,
        }
        $api.commission.calculate(data).then((response) => {
          if (response) {
            this.commission = response.data.userCom
          }
        }).catch((error) => {
          console.error('An error occurred.');
          $app.ui.notify('Упс... Не удалось получить комиссию', 'danger')

        })
      }
      return this.commission
    },
    calcAfterPayWithValidation(value) {
      const result = parseFloat(value) + this.calculateCommission(value)
      if (this.user.salaryStats.availableToTake < result) {
        this.$var('message', $n.t(3.34))
      }
      return $n.formatNumber(result)
    },
    calculateSumAfterCommission(value) {
      return this.company.getCommission === 'prePay' ?
          value - this.calculateCommission(value) :
          value;
    },
    isSumValid(value) {
      const sumAfterCommission = this.calculateSumAfterCommission(value)
      return value && sumAfterCommission >= 1000 && sumAfterCommission >= this.company.minimalTransactionSum;
    },
    takeSumProvider() {
      this.isLoading = true

      if (this.isSumValid(this.value) && this.firstStep) {
        this.doVerification(this.company.verificationType)
      } else {
        this.handleInvalidSum(this.value)
        this.isLoading = false
      }
    },
    doVerification(type) {

      const cardNumber = this.$form.input('cardNumber').value ?
          this.$form.input('cardNumber').value :
          this.card.title

      const data = {
        amount: this.value,
        pan: cardNumber.replace(/\s+/g, '').trim(),
        cardHolder: this.cardHolder,
        cardId: this.card.id === 'add' ? '' : this.card.id
      }

      const typeMethod = {
        OTP: () => {
          $api.transactions.createTransaction(data)
              .then((response) => {
                if (response.status === 200) {
                  this.loadDocument()
                  this.showDocumentModal = true
                  this.$store.commit('app/setTransactionData', response.data)
                }
              })
              .catch((error) => {
                const code = error
                let message;

                if (code === '3.28') {
                  message = $n.t(code) + this.company.maximalTransactionSum + ' ₸'
                } else {
                  message = $n.t(code);
                }
                $app.ui.notify(message || 'Произошла ошибка, попробуйте позднее (код 2)', 'danger')
                this.isLoading = false
              })
        },
        NO: () => {
          $api.transactions.createTransaction(data)
              .then((response) => {
                if (response.status === 200) {

                  $api.auth.sendCode(this.user.iin, this.user.phone)
                      .then((responseSendCode) => {
                        if (responseSendCode.data.data) {
                          this.$store.commit('app/setTransactionData', response.data.content) // устанавливаю transactionData в store
                          this.$store.dispatch('app/getStep', {router: this.$router})
                        }
                      })
                      .catch((error) => {
                        console.error('An error occurred.');
                        $app.ui.notify('При отправке кода произошла ошибка, попробуйте позднее', 'danger')
                      })
                }
              })
              .catch((error) => {
                const code = error
                let message;

                if (code === '3.28') {
                  message = $n.t(code) + this.company.maximalTransactionSum + ' ₸'
                } else {
                  message = $n.t(code);
                }
                $app.ui.notify(message || 'Произошла ошибка, попробуйте позднее (код 2)', 'danger')
                this.isLoading = false
              })
        }
      }
      return typeMethod[type]()
    },

    //* Работа с документом на подписание
    zoomIn() {
      this.scale -= 0.1
      this.loadPDF(this.scale)
    },
    zoomOut() {
      this.scale += 0.1
      this.loadPDF(this.scale)
    },
    async loadPDF(scaleP) {
      const pdfData = this.base64ToUint8Array(this.document.data)
      try {
        const pdf = await pdfjsLib.getDocument({data: pdfData,}).promise
        this.addSignatureDisable = false

        const container = document.getElementById('pdfContainer')
        container.innerHTML = ''
        for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
          // Создание элемента canvas для каждой страницы
          const page = await pdf.getPage(pageNumber)
          const canvas = document.createElement('canvas')
          canvas.style.display = 'block' // Установка стиля, чтобы canvas не сливались друг с другом
          const context = canvas.getContext('2d')
          if (scaleP === 0) {
            // Расчет масштаба и размеров вьюпорта
            const viewport = page.getViewport({scale: 1,})
            scaleP = container.offsetWidth / viewport.width
          }
          const scaledViewport = page.getViewport({scale: scaleP,})

          // Настройка размеров canvas
          canvas.width = scaledViewport.width
          canvas.height = scaledViewport.height

          // Добавление canvas в контейнер
          container.appendChild(canvas)

          // Отрисовка страницы
          const renderContext = {
            canvasContext: context,
            viewport: scaledViewport,
          }
          await page.render(renderContext).promise
        }
      } catch (error) {
        console.error('Error loading PDF')
        $app.ui.notify('Упс... Ошибка загрузки PDF', 'danger')
        this.$var('load', false)
      }
    },
    base64ToUint8Array(base64) {
      const raw = atob(base64)
      const uint8Array = new Uint8Array(raw.length)
      for (let i = 0; i < raw.length; i++) {
        uint8Array[i] = raw.charCodeAt(i)
      }
      return uint8Array
    },
    closeDocumentModal() {
      $api.eds.updateStatus().then(() => {
      }).catch((response) => {
        this.$var('message', $app.secure.clean(response.response.data.message.replace(/\n/g, '<br>')))
      })
      this.showDocumentModal = false
      this.$router.replace({name: 'mobile.index',})
    },
    loadDocument() {
      this.isLoading = true

      const document = 'application_otp'
      $api.document
          .generate(this.user.selectedCompany, document, {'sum': this.value,})
          .then((response) => {
            if (response.data) {
              this.document = response.data.content
              this.documentId = this.document.id
              this.link = `data:application/pdf;base64,${this.document.data}`
              this.loadPDF(0)
            }
            this.isLoading = false

          }).catch((err) => {
        $app.ui.notify(' Ошибка создания документа', 'danger')
        console.error('An error occurred.');
        this.isLoading = false

      })
    },
    async addSignature() {
      const data = {
        iin: this.user.iin,
        phone: this.user.phone,
        documentId: this.documentId
      }

      $api.auth.sendCodeOtp(data)
          .then((response) => {

            if (response.data.data) {
              this.showDocumentModal = false
              this.$store.dispatch('app/getStep', {router: this.$router})
            }

          })
          .catch((error) => {
            this.isLoading = false
            console.error('An error occurred.');
            $app.ui.notify('При отправке кода произошла ошибка, попробуйте позднее', 'danger')
          })
    },

    addProviderCard(type) {
      this.$form.set('cardNumber', '')
      this.showModalAgreement = false

      if (this.card?.id !== 'add') {
        this.isBtnDisabled = false
        this[type] = false
        this.cardNumber = ''
        this.cardHolder = ''
      } else {
        this.isBtnDisabled = false
        this[type] = true
      }
    },
    getButtonAmount() {
      if (this.company?.getCommission === 'afterPay') {
        if (this.user.company?.payoutProvider === 'buhta') {
          return +this.value + +this.calculateCommission(this.value);
        }
        if (this.user.company?.payoutProvider === 'bereke') {
          return this.calcAfterPayWithValidation(+this.value);
        }
      }
      return +this.value;
    },
    changeLoadingState(state) {
      this.$var('load', state)
    },
    toggleAgreement() {
      this.agreement = !this.agreement
    },
    openModalAgreement() {
      this.showModalAgreement = !this.showModalAgreement
    },
    updateNeedCheck(value) {
      this.needCheck = value;
    },
    isPaymentAllowed() {
      const {company, directorIsSignedAgreement, signedAgreement} = this.user;
      const {needFcbVerification, bin: companyBin} = company;

      const isTrustedCompany = Object.values(this.COMPANY_BINS).includes(companyBin);
      const hasBothSignatures = directorIsSignedAgreement && signedAgreement;

      // Case 1: FCB verification is needed and both agreements are signed
      if (needFcbVerification) {
        if (companyBin === this.COMPANY_BINS.TWO_WHEELS || companyBin === this.COMPANY_BINS.TWO_WHEELS_SECOND) {
          if (!signedAgreement) {
            return false;
          }
        } else {
          if (!hasBothSignatures) {
            return false;
          }
        }
      }
      // Case 2: Company is trusted and user has signed agreement
      if (isTrustedCompany) {
        if (!signedAgreement) {
          return false;
        }
      }
      return true;
    },
  }
}
</script>

<style lang="scss" scoped src="./payment.scss"></style>
